import axios from 'axios';
import config from '../../config';

const state = {
  sid: null,
  clubId: null,
  locale: 'RU',
  loading: false,
  balance: 0,
  currency: 'UAH',
  notification: null,
  invoices: [],
  invoicesTransactions: [],
  invoiceToRemove: null,
  clubTransfers: [],
};
const getters = {
  lang() {
    return state.lang;
  },
  loading() {
    return state.loading;
  },
  balance() {
    return state.balance;
  },
  currency() {
    return state.currency;
  },
  invoices()  {
    return state.invoices;
  },
  invoicesTransactions() {
    return state.invoicesTransactions;
  },
  invoiceToRemove() {
    return state.invoiceToRemove;
  },
  notification() {
    return state.notification;
  },
  clubTransfers() {
    return state.clubTransfers;
  },
  terminals() {
    return state.players.filter(player => player.playerType === 'TERMINAL');
  },
};
const actions = {
  async ping({ commit, state }) {
    try {
      await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'ping',
          clubId: state.clubId,
        }
      });
    } catch (e) {
      window.localStorage.removeItem('sid');
      window.localStorage.removeItem('role');
      window.localStorage.removeItem('roleId');
      window.localStorage.removeItem('username');
      commit('setSid', null);
      commit('setError', 'Ваша попытка входа не удалась, попробуйте еще раз.');
      this.$router.replace('/login');
    }
  },
  async getClub({ commit, state }) {
    commit('setLoading');
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'getClub',
          clubId: state.clubId,
        }
      });
      commit('setCurrency', data.response.currency);
      commit('setInvoices', data.response.invoices);
      commit('setBalance', data.response.balance);
      commit('unsetLoading');
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async getClubTransfers({ commit, state }, { min, max }) {
    commit('setLoading');
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'getClubTransfers',
          clubId: state.clubId,
          min,
          max
        }
      });
      commit('setClubTransfers', data.response.transfers);
      commit('unsetLoading');
      return data.response;
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async getInvoice({ commit, state }, { playerId }) {
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'getInvoice',
          clubId: state.clubId,
          playerId
        }
      });
      return data.response;
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async getInvoiceEvents({ commit, state }, { playerId, skip = 0 }) {
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'getInvoiceEvents',
          clubId: state.clubId,
          playerId,
          skip
        }
      });
      return data.response;
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async getInvoiceTransfers({ commit, state }, { playerId }) {
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'getInvoiceTransfers',
          clubId: state.clubId,
          playerId
        }
      });
      return data.response;
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async createInvoice({ commit, state }, { amount, description }) {
    commit('setLoading');
    try {
      const amountInSystem = Math.floor(parseFloat(amount) * 100);
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'createInvoice',
          clubId: state.clubId,
          amount: amountInSystem,
          description
        }
      });
      commit('setNotification', { type: 'INVOICE_CREATE', ...data.response });
    } catch (e) {
      commit('setNotification', { type: 'ERROR', message: e.message });
    }
  },
  async depositToInvoice({ commit, state }, { playerId, amount }) {
    commit('setLoading');
    try {
      await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'depositToInvoice',
          clubId: state.clubId,
          playerId,
          amount
        }
      });
      const invoice = state.invoices.filter(invoice => invoice.playerId === playerId)[0];
      commit('setNotification', { type: 'INVOICE_DEPOSIT', ...invoice, amount });
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e });
    }
  },
  async withdrawFromInvoice({ commit, state }, { playerId, amount }) {
    commit('setLoading');
    try {
      await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'withdrawFromInvoice',
          clubId: state.clubId,
          playerId,
          amount
        }
      });
      const invoice = state.invoices.filter(invoice => invoice.playerId === playerId)[0];
      commit('setNotification', { type: 'INVOICE_WITHDRAW', ...invoice, amount });
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async withdrawAllFromInvoice({ commit, state }, { playerId }) {
    commit('setLoading');
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'withdrawAllFromInvoice',
          clubId: state.clubId,
          playerId
        }
      });
      const { amount } = data.response;
      const invoice = state.invoices.filter(invoice => invoice.playerId === playerId)[0];
      commit('setNotification', { type: 'INVOICE_WITHDRAW', ...invoice, amount });
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async lockInvoice({ commit, state }, { playerId }) {
    try {
      await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'lockInvoice',
          clubId: state.clubId,
          playerId
        }
      });
      const invoice = state.invoices.filter(invoice => invoice.playerId === playerId)[0]
      invoice.locked = true;
      commit('setNotification', { type: 'INVOICE_LOCK', ...invoice });
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async unlockInvoice({ commit, state }, { playerId }) {
    try {
      await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'unlockInvoice',
          clubId: state.clubId,
          playerId
        }
      });
      const invoice = state.invoices.filter(invoice => invoice.playerId === playerId)[0];
      invoice.locked = false;
      commit('setNotification', { type: 'INVOICE_UNLOCK', ...invoice });
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async removeInvoice({ commit, dispatch, state }) {
    commit('setLoading');
    const invoice = state.invoiceToRemove;
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'removeInvoice',
          clubId: state.clubId,
          playerId: invoice.playerId,
        }
      });
      await dispatch('getClub');
      commit('setInvoiceToRemove', null);
      commit('setNotification', { type: 'INVOICE_REMOVE', ...invoice, amount: data.response.amount })
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
  async setInvoiceToRemove({ commit, state }, { playerId } = {}) {
    const invoice = state.invoices.filter(invoice => invoice.playerId === playerId)[0];
    commit('setInvoiceToRemove', invoice);
  },
  async getInvoicesTransactions({ commit, state }, { min, max }) {
    commit('setLoading');
    try {
      const { data } = await axios.get(config.clubUrl, {
        params: {
          sid: state.sid,
          action: 'getInvoicesTransactions',
          clubId: state.clubId,
          min,
          max
        }
      });
      commit('setInvoicesTransactions', data.response.transactions);
      commit('unsetLoading');
    } catch (e) {
      commit('setNotification', { type: 'ERROR', ...e.response.data });
    }
  },
};
const mutations = {
  setSid(state, value) {
    state.sid = value;
  },
  setClubId(state, value) {
    state.clubId = value;
  },
  setLoading(state) {
    state.loading = true;
  },
  unsetLoading(state) {
    state.loading = false;
  },
  setBalance(state, value) {
    state.balance = value;
  },
  setCurrency(state, value) {
    state.currency = value;
  },
  setNotification(state, params) {
    state.loadinga = false;
    state.notification = params;
  },
  setInvoices(state, value) {
    state.invoices = value;
  },
  setInvoicesTransactions(state, transactions) {
    if (!Array.isArray(transactions)) {
      throw new Error('invalid type of transactions');
    }
    state.invoicesTransactions = transactions;
  },
  setInvoiceToRemove(state, invoice) {
    state.invoiceToRemove = invoice;
  },
  setClubTransfers(state, transfers) {
    if (!Array.isArray(transfers)) {
      throw new Error('invalid transfers');
    }
    state.clubTransfers = transfers;
  },
};

export default { state, getters, actions, mutations };
